import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { swatch } from '@wordpress/icons';
/**
 * Internal dependencies
 */

import Icon from '../icon';

function Swatch(_ref) {
  let {
    fill
  } = _ref;
  return fill ? createElement("span", {
    className: "components-swatch",
    style: {
      background: fill
    }
  }) : createElement(Icon, {
    icon: swatch
  });
}

export default Swatch;
//# sourceMappingURL=index.js.map